export const TREATMENTSTEP_LIST_REQUEST = "TREATMENTSTEP_LIST_REQUEST";
export const TREATMENTSTEP_LIST_SUCCESS = "TREATMENTSTEP_LIST_SUCCESS";
export const TREATMENTSTEP_LIST_FAIL = "TREATMENTSTEP_LIST_FAIL";

export const TREATMENTSTEP_DETAILS_REQUEST = "TREATMENTSTEP_DETAILS_REQUEST";
export const TREATMENTSTEP_DETAILS_SUCCESS = "TREATMENTSTEP_DETAILS_SUCCESS";
export const TREATMENTSTEP_DETAILS_FAIL = "TREATMENTSTEP_DETAILS_FAIL";

export const TREATMENTSTEP_CREATE_REQUEST = "TREATMENTSTEP_CREATE_REQUEST";
export const TREATMENTSTEP_CREATE_SUCCESS = "TREATMENTSTEP_CREATE_SUCCESS";
export const TREATMENTSTEP_CREATE_FAIL = "TREATMENTSTEP_CREATE_FAIL";
export const TREATMENTSTEP_CREATE_RESET = "TREATMENTSTEP_CREATE_RESET";

export const TREATMENTSTEP_UPDATE_REQUEST = "TREATMENTSTEP_UPDATE_REQUEST";
export const TREATMENTSTEP_UPDATE_SUCCESS = "TREATMENTSTEP_UPDATE_SUCCESS";
export const TREATMENTSTEP_UPDATE_FAIL = "TREATMENTSTEP_UPDATE_FAIL";
export const TREATMENTSTEP_UPDATE_RESET = "TREATMENTSTEP_UPDATE_RESET";

export const TREATMENTSTEP_DELETE_REQUEST = "TREATMENTSTEP_DELETE_REQUEST";
export const TREATMENTSTEP_DELETE_SUCCESS = "TREATMENTSTEP_DELETE_SUCCESS";
export const TREATMENTSTEP_DELETE_FAIL = "TREATMENTSTEP_DELETE_FAIL";
export const TREATMENTSTEP_DELETE_RESET = "TREATMENTSTEP_DELETE_RESET";
